// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__dvLOl","card":"NotFound_card__8jYUZ","img":"NotFound_img__xbct9","title":"NotFound_title__OQ-MU"};